'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const styles = {
  wrapper: {
    display: 'flex',
    position: 'relative',
    textAlign: 'initial'
  },
  fullWidth: {
    width: '100%'
  },
  hide: {
    display: 'none'
  }
};

exports.default = styles;
